import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ContractFactory from "../../Entity/Factories/ContractFactory";

export default function* contractList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "contracts");

    // Iterate through each raw contract data and convert them to objects.
    const contracts = res.data.data.map(contract => {
      return ContractFactory.create(contract);
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_LIST_SUCCESS,
      payload: {
        contracts: contracts
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchContractList() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_LIST, contractList);
}
